import CssBaseLine from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SignInTable from './SignInTable';
    

const SignIn = () => {  
  return (
       <> <CssBaseLine />
        <Grid container spacing={3} style={{ flex: '1', width: '100%' }}>
          <Container>
            <Grid item xs={12} md={4} style={{ paddingTop: '40px',}}> 
              <SignInTable /> 
            </Grid>
          </Container>
        </Grid> 
      </>
    );
}

export default SignIn;